import styled, { css } from 'styled-components';

export const Root = styled.div`
	display: flex;
	justify-content: space-between;
	background-color: transparent;
`;

export const ActiveButton = css`
	color: ${(props) => props.theme.primaryColor};
	${({ theme }) => theme && theme.typography.textMediumS};
	font-weight: bold;
	cursor: auto;
	pointer-events: none;
`;

export const NextButton = css`
	border: 2px solid #f0f1f4;
	border-radius: 40px;
`;

export const PrevButton = css`
	border: 2px solid #f0f1f4;
	border-radius: 40px;
`;

export const Pages = styled.div``;

export const StyledArrow = styled.svg`
	width: 10px;
	height: 10px;
	align-self: center;
	justify-self: center;
	fill: ${({ theme }) => theme.darkGrayColor};
`;

export const StyledArrowBack = styled(StyledArrow)`
	transform: rotate(180deg);
`;

export const Button = styled.button`
	min-width: 32px;
	min-height: 32px;
	color: ${({ theme }) => theme.darkGrayColor};
	border: none;
	cursor: pointer;
	transition: color 0.15s ease;
	padding: 0;
	margin: 0 8px;
	@media (max-width: 366px) {
		margin: 0 4px;
	}
	${({ theme }) => theme && theme.typography.textMediumS}
	&:hover {
		color: ${(props) => props.theme.primaryColor};
		font-weight: bold;
	}

	${(props) => props.next && NextButton}
	${(props) => props.prev && PrevButton}
	${(props) => props.isActive && ActiveButton}
`;
